import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { messages } from './messages';
import style from './style.module.less';

export const ResultRow = ({ isCancelled, orderNumber }) => {
  const resultMessage = isCancelled ? <FormattedMessage {...messages.cancelled} /> : <FormattedMessage {...messages.errored} />;
  return (
    <>
      <div className={style.cell}>{orderNumber}</div>
      <div className={style.cell}>{resultMessage}</div>
    </>
  );
};

ResultRow.propTypes = {
  fulfillmentId: PropTypes.number.isRequired,
  isCancelled: PropTypes.bool.isRequired,
  orderNumber: PropTypes.string.isRequired,
};
